<!--
 * @Author:
 * @Description: 对象信息
-->
<template>
  <div class="h-full pt-10px pb-10px">
    <nav-menus
      :menuList="menuList"
      :activeIndex="activeIndex"
      @selectIndex="selectIndex"
    ></nav-menus>
    <!-- 基本属性 -->
    <div v-if="activeIndex === 0" class="pt-10px overflow-auto h-[calc(100%-48px)]">
      <div class="flex justify-start item-start mb-10px" v-if="classTypeTableData.length > 0">
        <img src="../../../assets/images/titleIcon.png" alt="" />
        <span class="text-16px text-white custom-shadow ml-4px"> 基本属性 </span>
      </div>
      <div
        class="mb-10px text-white border-2px p-10px rounded-5px border-[#45f2eb33]"
        v-if="classTypeTableData.length > 0"
      >
        <div class="flex" v-for="(item, index) in classTypeTableData" :key="index">
          <div class="text-[#c3c3c3]">{{ item.name }}：</div>
          <el-tooltip
            :content="item.value"
            placement="top"
            :open-delay="500"
            :disabled="!item.value"
          >
            <div class="flex-1 truncate">{{ item.value }}</div>
          </el-tooltip>
        </div>
      </div>
      <div v-for="(value, key, index) in dynamicTableGroupData" :key="index">
        <div
          v-if="
            value.filter((e) => {
              return e.show === true
            }).length > 0
          "
        >
          <CategoryTitle class="mt-5px mb-10px" :title="key"></CategoryTitle>
          <div class="mb-10px text-white border-2px p-10px rounded-5px border-[#45f2eb33]">
            <div>
              <div class="flex" v-for="(cItem, cIndex) in value" :key="cIndex">
                <div v-if="cItem.show" class="text-[#c3c3c3]">{{ cItem.name }}：</div>
                <el-tooltip
                  v-if="cItem.show"
                  :content="cItem.value"
                  placement="top"
                  :open-delay="500"
                  :disabled="!cItem.value"
                >
                  <div class="flex-1 truncate">{{ cItem.value }}</div>
                </el-tooltip>
              </div>
            </div>
            <!-- 扩展属性一对多列表 -->
            <div v-if="flag === 1 && value.length === 0">
              <el-table
                :data="extendValueList"
                :highlight-current-row="true"
                :header-cell-style="{ textAlign: 'center' }"
                :cell-style="{ textAlign: 'center' }"
                height="248"
                row-key="id"
                stripe
              >
                <el-table-column
                  type="index"
                  width="65"
                  label="序号"
                  prop="seqNo"
                ></el-table-column>
                <el-table-column
                  v-for="(item, index) in extendTableHeader"
                  :key="index"
                  :label="item.name"
                  :prop="`${item.tableName}.${item.columnName}`"
                  show-overflow-tooltip
                >
                  <template slot-scope="scope">
                    {{ scope.row[`${item.tableName}.${item.columnName}`] }}
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination
                class="mt-20px"
                background
                @size-change="searchList()"
                @current-change="getList()"
                :current-page.sync="page.pageNo"
                :page-sizes="$pageSizeAll"
                :page-size.sync="page.pageSize"
                layout="->, total, sizes, prev, pager, next"
                :total="page.total"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 关联文档 -->
    <div v-if="activeIndex === 1" class="pt-10px overflow-auto h-[calc(100%-48px)]">
      <div v-for="(item, index) in assocFilesList" :key="index">
        <div class="flex justify-start item-start mb-10px">
          <img src="../../../assets/images/titleIcon.png" alt="" />
          <span class="text-16px text-white custom-shadow ml-4px"> {{ item.nodeName }} </span>
        </div>
        <div class="mb-10px text-white border-2px p-10px rounded-5px border-[#45f2eb33]">
          <div class="flex" v-for="(cItem, cIndex) in item.childrenNodes" :key="cIndex">
            <el-tooltip :content="cItem.fileName" placement="top" :open-delay="500">
              <div class="flex-1 truncate">{{ cItem.fileName }}</div>
            </el-tooltip>
            <div class="flex">
              <el-tooltip content="弹窗" placement="top" :open-delay="500">
                <img
                  src="../../../assets/images/objInfo/dialog.png"
                  alt=""
                  @click="openDialog(cItem)"
                />
              </el-tooltip>
              <el-tooltip content="侧边弹窗" placement="top" :open-delay="500">
                <img
                  src="../../../assets/images/objInfo/split_screen.png"
                  alt=""
                  @click="splitScreen(cItem)"
                />
              </el-tooltip>
              <el-tooltip
                v-if="splitShow"
                class="ml-2px"
                content="分屏"
                placement="top"
                :open-delay="500"
              >
                <img
                  src="../../../assets/images/objInfo/split.png"
                  alt=""
                  @click="realSplitScreen(cItem)"
                />
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 关联对象 -->
    <div v-if="activeIndex === 2" class="pt-10px overflow-auto h-[calc(100%-48px)]">
      <!-- 上级对象 -->
      <div class="flex justify-start item-start mb-10px" v-if="parentObject.length > 0">
        <img src="../../../assets/images/titleIcon.png" alt="" />
        <span class="text-16px text-white custom-shadow ml-4px"> 上级对象 </span>
      </div>
      <div
        class="mb-10px text-white border-2px p-10px rounded-5px border-[#45f2eb33]"
        v-if="parentObject.length > 0"
      >
        <div
          v-for="(item, index) in parentObject"
          :key="index"
          class="truncate"
          :class="currentNode.nodeCode === item.nodeCode ? 'active' : ''"
          @click="handleNodeClick(item)"
        >
          <el-tooltip
            :content="`${item.nodeCode}【${item.nodeName}】`"
            placement="top"
            :open-delay="500"
          >
            <span>{{ item.nodeCode }}【{{ item.nodeName }}】</span>
          </el-tooltip>
        </div>
      </div>
      <!-- 下级对象 -->
      <div class="flex justify-start item-start mb-10px" v-if="subObject.length > 0">
        <img src="../../../assets/images/titleIcon.png" alt="" />
        <span class="text-16px text-white custom-shadow ml-4px"> 下级对象 </span>
      </div>
      <div
        class="mb-10px text-white border-2px p-10px rounded-5px border-[#45f2eb33]"
        v-if="subObject.length > 0"
      >
        <div
          v-for="(item, index) in subObject"
          :key="index"
          class="truncate"
          :class="currentNode.nodeCode === item.nodeCode ? 'active' : ''"
          @click="handleNodeClick(item)"
        >
          <el-tooltip
            :content="`${item.nodeCode}【${item.nodeName}】`"
            placement="top"
            :open-delay="500"
          >
            <span>{{ item.nodeCode }}【{{ item.nodeName }}】</span>
          </el-tooltip>
        </div>
      </div>
      <!-- 关联对象 -->
      <div class="flex justify-start item-start mb-10px" v-if="assocTagsList.length > 0">
        <img src="../../../assets/images/titleIcon.png" alt="" />
        <span class="text-16px text-white custom-shadow ml-4px"> 关联对象 </span>
      </div>
      <div
        class="mb-10px text-white border-2px p-10px rounded-5px border-[#45f2eb33]"
        v-if="assocTagsList.length > 0"
      >
        <div
          v-for="(item, index) in assocTagsList"
          :key="index"
          class="truncate"
          :class="currentNode.code === item.code ? 'active' : ''"
          @click="handleNodeClick(item)"
        >
          <el-tooltip :content="`${item.code}【${item.name}】`" placement="top" :open-delay="500">
            <span>{{ item.code }}【{{ item.name }}】</span>
          </el-tooltip>
        </div>
      </div>
    </div>

    <!-- 查看文件弹窗 -->
    <objDialog
      v-if="showDialog"
      width="800px"
      height="550px"
      top="120px"
      left="630px"
      :dialogForm="dialogForm"
      @closeObjInfo="closeObjInfo"
      @splitScreen="splitScreen"
      @svgTrigger="svgTrigger"
      type="dialog"
      :player="player"
      :standardId="standardId"
    />
  </div>
</template>

<script>
import CategoryTitle from '@/components/cockpit/CategoryTitle'
import HandoverService from '../../../service/HandoverService'
import navMenus from '../metalComponents/NavMenus'
import objDialog from './objDialog'

export default {
  props: {
    // 显示对象信息的文件弹窗
    showObjInfoDialog: {
      type: Boolean,
      default: false,
    },
    // 移交对象传过来的数据
    transferProps: {
      type: Object,
      defalut: () => {
        return {}
      },
    },
    player: {
      type: Object,
      default: () => {},
    },
  },
  components: { CategoryTitle, navMenus, objDialog },
  data() {
    return {
      activeIndex: 0,
      menuList: [
        {
          lable: '属性',
          isDrop: false,
        },
        {
          lable: '关联文档',
          isDrop: false,
        },
        {
          lable: '关联对象',
          isDrop: false,
        },
      ],
      splitShow: false, // 是否显示分屏按钮
      showDialog: false,
      dialogForm: {},
      basicAttrObj: {}, // 基本属性
      entityAttrList: [], // 实体属性
      assocFilesList: [], // 关联文档
      parentObject: [], // 上级对象
      subObject: [], // 下级对象
      assocTagsList: [], // 关联对象
      currentNode: {},
      standardList: [],
      standardId: '',
      dynamicTableData: [],
      classTypeTableData: [],
      dynamicTableGroupData: [],
      codeInfo: {},
      defaultCameraInfo: null, // 默认视角参数
      isExtend: null,
      isPrimary: null,
      extendValue: null,
      page: {
        pageNo: 1,
        pageSize: 15,
        total: 0,
      },
      flag: null,
    }
  },
  watch: {
    showObjInfoDialog(newVal) {
      if (newVal) {
        this.showDialog = true
      }
    },
    transferProps: {
      handler(data) {
        if (data && data.code && data.flag === 0) {
          this.getAllInfo(data.code, data.standardId)
          this.standardId = data.standardId
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    // 获取code的id
    async getCodeId(code, standardId) {
      const [err, res] = await HandoverService.getCodeId({
        standardId,
        code,
        cateCode: 'Tag',
      })
      if (!err && res && res.code === 0 && res.data?.id) {
        this.codeInfo = res.data
        this.getDynamicTableData(code, standardId)
        this.getPersonalityMetaAttr(standardId)
        this.getAssociatedFiles(this.codeInfo.id, standardId)
        this.getParentAndSubObj(this.codeInfo.id, standardId)
        this.getAssociatedTags(this.codeInfo.id, standardId)
      } else {
        this.codeInfo = {}
      }
    },
    async getPersonalityMetaAttr(mStandardId) {
      const [dErr, dRes] = await HandoverService.getPersonalityMetaDefine({
        standardId: mStandardId,
        stdPersonalityMetaDataType: 1,
        columnName: 'Delivery_level',
      })
      if (!dErr && dRes && dRes.code === 0 && dRes.data) {
        const [err, res] = await HandoverService.getPersonalityMetaData({
          classId: this.codeInfo.class_id,
          stdPersonalityMetaDataId: dRes.data[0].id,
        })
        if (!err && res && res.code === 0 && res.data) {
          this.personalityMetaAttr = res.data
        }
      }
    },
    // 获取动态表单数据
    async getDynamicTableData(code, standardId) {
      const [err, res] = await HandoverService.getDynamicTableData({
        classId: this.codeInfo.class_id,
        dataId: this.codeInfo.id,
      })
      if (!err && res && res.code === 0 && res.data) {
        this.dynamicTableData = res.data
        this.getClassTypeTableHeader(code, standardId)
        this.getDynamicTableGroupHeader()
      } else {
        this.dynamicTableData = []
      }
    },
    // 获取实体类型动态表头
    async getClassTypeTableHeader(code, standardId) {
      if (!this.codeInfo.class_id) return
      const [err, res] = await HandoverService.getClassTypeTableHeader({
        standardId,
        classId: this.codeInfo.class_id,
        cateCode: 'Tag',
      })
      if (!err && res && res.code === 0 && res.data) {
        this.classTypeTableData = res.data
        Object.keys(this.dynamicTableData).forEach((key) => {
          _.map(this.classTypeTableData, (item) => {
            if (key === `${item.tableName}.${item.columnName}`) {
              item.value = this.dynamicTableData[key]
            }
            if (item.isPrimary) this.isPrimary = item
            return item
          })
        })
      } else {
        this.classTypeTableData = []
      }
    },
    // 获取实体分组动态表头
    async getDynamicTableGroupHeader() {
      if (!this.codeInfo.class_id) return
      const [err, res] = await HandoverService.getDynamicTableGroupHeader({
        classId: this.codeInfo.class_id,
      })
      if (!err && res && res.code === 0 && res.data) {
        this.dynamicTableGroupData = res.data
        Object.keys(this.dynamicTableGroupData).forEach((groupKey) => {
          Object.keys(this.dynamicTableData).forEach((key) => {
            _.map(this.dynamicTableGroupData[groupKey], (item) => {
              if (key === `${item.tableName}.${item.columnName}`) {
                const deliveryLevel = this.personalityMetaAttr.find((e) => {
                  return e.relationId === item.id
                })?.dataValue
                item.value = this.dynamicTableData[key]
                item.show = !(deliveryLevel === '选填' && item.value == null)
              }
              return item
            })
          })
          this.dynamicTableGroupData[groupKey].forEach((obj) => {
            if (obj.isExtend === 1) this.isExtend = obj
          })
        })
        if (this.isExtend) {
          await this.getExtensionList()
          await this.getExtendDataList()
        }
      } else {
        this.dynamicTableGroupData = []
      }
    },
    // 获取扩展属性下拉数据
    async getExtensionList() {
      const [err, res] = await HandoverService.getExtendClassList({
        classId: this.isExtend.classId,
      })
      if (!err && res && res.code === 0) {
        this.extendValue = res.data.find((item) => {
          return item.extendClassCode === this.isExtend.value
        })
      }
    },
    // 获取扩展属性数据
    async getExtendDataList() {
      if (!this.extendValue || !this.extendValue.extendClassCode) return
      const params = {
        maxResultCount: this.page.pageSize,
        skipCount: this.page.pageSize * (this.page.pageNo - 1),
        attributeId: this.extendValue.classAttributeId,
        attributeData: this.extendValue.extendClassCode,
        data: this.isPrimary.value,
      }
      const [err, res] = await HandoverService.getExtendData(params)
      if (!err && res && res.code === 0) {
        this.flag = res.data.flag
        // this.flag = 1
        if (this.flag === 0) {
          const val = res.data.data?.data[0]
          Object.keys(val).forEach((item) => {
            res.data.attributeDataModels.forEach((el) => {
              if (`${el.tableName}.${el.columnName}` === item) {
                el.value = val[item]
              }
            })
          })
          this.$set(
            this.dynamicTableGroupData,
            this.extendValue.extendClassName,
            res.data.attributeDataModels
          )
        } else {
          this.extendTableHeader = res.data.attributeDataModels
          this.extendValueList = res.data.data.data
          this.page.total = res.data.data.totalCount
          this.$set(this.dynamicTableGroupData, this.extendValue.extendClassName, [])
        }
      }
    },
    // 模型点选
    async watchMsg(e) {
      // vk
      if (e?.node) {
        const nodeInfo = await this.player.Native.Node.getProperty(e.node, ['code'])
        if (nodeInfo.code) {
          this.getAllInfo(nodeInfo.code, this.standardId)
        }
      }
    },
    getAllInfo(code, standardId) {
      this.getCodeId(code, standardId)
    },
    async getStandardList() {
      const [err, res] = await HandoverService.getStandardList()
      if (!err && res && res.code === 0 && res.data) {
        this.standardList = res.data
        this.standardId = res.data[0].id
      } else {
        this.standardList = []
        this.standardId = ''
      }
    },
    selectIndex(index) {
      this.activeIndex = index
    },
    openDialog(val) {
      if (val.defaultFileId && val.defaultFileId.includes('http')) {
        window.open(val.defaultFileId)
        return
      }
      this.showDialog = false
      this.$nextTick(() => {
        this.showDialog = true
      })
      this.dialogForm = _.cloneDeep(val)
    },
    closeObjInfo() {
      this.showDialog = false
    },
    // 分屏
    splitScreen(val) {
      this.showDialog = false
      const obj = {
        width: document.documentElement.clientWidth / 2,
        height: document.documentElement.clientHeight - 100,
        dialogForm: val,
        standardId: this.standardId,
      }
      this.sendInfoToRightDialog('mainComponent', obj)
    },
    realSplitScreen(val) {
      this.showDialog = false
      this.$emit('transferEvent', {
        toCom: { code: 'ObjectFileSplit', origin: 'ObjectInfo', name: '移交对象' },
        props: {
          formData: val,
          standardId: this.standardId,
        },
      })
    },
    // 获取关联文档
    async getAssociatedFiles(id, standardId) {
      if (!id) return
      const [err, res] = await HandoverService.getAssociatedFiles({ id, standardId })
      if (!err && res && res.code === 0 && res.data) {
        this.assocFilesList = res.data
      } else {
        this.assocFilesList = []
      }
    },
    // 获取上下级对象
    async getParentAndSubObj(id, standardId) {
      if (!id) return
      const [err, res] = await HandoverService.getParentAndSubObj({ id, standardId })
      if (!err && res && res.code === 0 && res.data) {
        _.map(res.data, (item) => {
          if (item.nodeName === '上级对象') {
            this.parentObject = item.childrenNodes
          }
          if (item.nodeName === '下级对象') {
            this.subObject = item.childrenNodes
          }
        })
      } else {
        this.parentObject = []
        this.subObject = []
      }
    },
    // 获取关联对象
    async getAssociatedTags(id, standardId) {
      if (!id) return
      const [err, res] = await HandoverService.getAssociatedTags({
        keyword: '',
        sort: 'created_time desc',
        pageIndex: 1,
        pageSize: 999,
        standardId,
        id,
      })
      if (!err && res && res.code === 0 && res.data) {
        this.assocTagsList = res.data
      } else {
        this.assocTagsList = []
      }
    },
    // 传递信息给移交对象
    sendInfoToRightDialog(type, data = {}) {
      this.$emit('transferEvent', {
        toCom: { code: 'HandoverObject', origin: 'ObjectInfo', name: '移交对象' },
        type,
        props: {
          ...data,
          openAlarmFlicker: true,
          flickerFrequency: 500,
        },
      })
    },
    // 点击节点
    async handleNodeClick(node) {
      this.currentNode = node
      if (node.nodeCode || node.code) {
        // 通过位号查找节点
        const code = node.nodeCode || node.code
        // vk
        const rootNode = await this.player.Native.Node.getRoot()
        const codeData = await this.player.Native.Node.findNode(rootNode, {
          codes: [decodeURIComponent(code)],
        })
        const codes = codeData?.codes
        if (codes && codes[decodeURIComponent(code)] && codes[decodeURIComponent(code)].node) {
          this.sendInfoToRightDialog('mainComponent', node)
          // 设置当前选中节点，不触发事件
          await this.player.Native.Node.unSelectNodes([])
          this.player.Native.Node.selectNodes([codes[decodeURIComponent(code)].node])
          // 设置点选时其他节点半透明
          // this.player.Native.Setting.set('color.pickup.bkAlpha', 'float', 0.4)
          // 外层添加包裹盒子
          // this.player.Native.Setting.set('pickup.highlight', 'bool', true)
          // this.player.Native.Setting.set('show.select.box', 'bool', true)
          // 计算节点包围盒
          // const NodeInfo = await this.player.Native.Node.getProperty(
          //   codes[decodeURIComponent(code)].node,
          //   ['aabb']
          // )
          // 相机移动到包围盒位置
          this.player.Native.Camera.moveToNode(codes[decodeURIComponent(code)].node, 2, 5)
        }
      }
    },
    // 点击svg触发事件
    svgTrigger(val) {
      console.log(val, 'svgTrigger111')
      // 点击Svg空白处时不触发事件，避免传空值导致接口返回错误数据
      if (val.code) {
        this.getCodeId(val.code, this.standardId)
      } else {
        this.codeInfo = {}
      }
    },
    // 恢复相机
    async resetCamera() {
      await this.player.Native.Camera.moveTo(
        this.defaultCameraInfo.eye,
        this.defaultCameraInfo.target,
        this.defaultCameraInfo.up,
        1
      )
    },
  },
  async created() {
    if (this.$route.query.modelInfoId) {
      this.splitShow = true
    }
    // 先点击模型节点，再打开对象信息面板
    const currentModelNodeCode = localStorage.getItem('currentModelNodeCode')
    if (currentModelNodeCode) {
      await this.getStandardList()
      this.getAllInfo(currentModelNodeCode, this.standardId)
    }
  },
  async mounted() {
    this.defaultCameraInfo = await this.player.Native.Camera.currentParam() // 获取默认相机信息
    // 先打开对象信息面板，再点击模型节点
    // 监听选择节点切换事件
    // vk
    this.player.Native.OperatingMode.EventPickUpNode.connect(this.watchMsg)
  },
  async beforeDestroy() {
    // 取消选中节点
    // vk
    await this.player.Native.Node.unSelectNodes([])
    this.player.Native.OperatingMode.EventPickUpNode.disconnect(this.watchMsg)
    this.resetCamera()
  },
}
</script>

<style lang="scss" scoped>
.active {
  background: #005d657f !important;
}
</style>
